
export default function ManuResSyncPlugin({ isMaster = false } = {}) {
    return (store) => {
        window.electronAPI.on('file-manu-res', ({filePath, manuRes}) => {
            console.log("get file-manu-res", manuRes)
            // 直接替换本地 store 的状态
            store.state.commonObjList.forEach(item => {
                if (item.file_path !== filePath) {
                    return
                }
                item.ManuRes = manuRes
                if (item.ManuResProcessor) {
                    item.ManuResProcessor()
                }
            })
        });
    };
}